import { render, staticRenderFns } from "./LibraryOverview.vue?vue&type=template&id=5dd676cc"
import script from "./LibraryOverview.vue?vue&type=script&lang=js"
export * from "./LibraryOverview.vue?vue&type=script&lang=js"
import style0 from "./LibraryOverview.vue?vue&type=style&index=0&id=5dd676cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports